// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShowFailedPayout-commonHeaderAdmin-JgIjh {
	position: fixed !important;
}

.ShowFailedPayout-adminLayout-Cbt6I {
	padding-top: 64px !important;
}

.ShowFailedPayout-box-IKX6n h2 {
	font-size: 21px;
	font-weight: 600;
}

.ShowFailedPayout-exportLink-xwnSy {
	margin-bottom: -29px;
}

.ShowFailedPayout-blockCenter-nPmNb {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ShowFailedPayout-panelHeader-kJmgv {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ShowFailedPayout-currencyselect-mbFOq {
	width: 100%;
	margin-right: 0px;
}

.ShowFailedPayout-panelHeader-kJmgv {
	overflow: hidden;
	position: relative;
}

.ShowFailedPayout-mar0-Ey9FN {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ShowFailedPayout-blockCenter-nPmNb {
		padding: 0px;
	}

	.ShowFailedPayout-panelHeader-kJmgv {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ShowFailedPayout-sideAdminPageWrapper-wOqxo {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ShowFailedPayout-panelHeader-kJmgv {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ShowFailedPayout-table-fuz4d {
	display: table;
}

.ShowFailedPayout-tableRow-XfGlr {
	display: table-row;
}

.ShowFailedPayout-tableCell-dNtMh {
	display: table-cell;
	float: none;
}

.ShowFailedPayout-formGroup-XFHA2 {
	margin-bottom: 6px;
}

.ShowFailedPayout-select-PKngM {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ShowFailedPayout-noMargin-MtIFx {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ShowFailedPayout-exportLink-xwnSy {
	padding-top: 10px;
	padding-right: 10px;
}

.ShowFailedPayout-labelTextNew-N1yjv {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ShowFailedPayout-displayInline-O3CLu {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ShowFailedPayout-btnUPdate-ybKCP {
	display: inline-block;
}

.ShowFailedPayout-btnModalDelete-hROaZ {
	display: inline-block;
	margin-left: 15px;
}

.ShowFailedPayout-radioBtn-k2ezm {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ShowFailedPayout-backgroundImg-GLfK8 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ShowFailedPayout-btnUPdate-ybKCP {
		display: block;
		margin-bottom: 12px;
	}

	.ShowFailedPayout-btnModalDelete-hROaZ {
		display: block;
		margin-left: 0px;
	}

	.ShowFailedPayout-btnWidth-upd2v {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ShowFailedPayout-bannerImageBg-sxKF0 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ShowFailedPayout-bannerDelete-GC51s {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ShowFailedPayout-modalRoot-AmDII {
	padding: 32px;
}

.ShowFailedPayout-modalBorderBottom-uLvM7 {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ShowFailedPayout-logInModalBody-YjISC {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ShowFailedPayout-exportSection-iTrxO {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ShowFailedPayout-exportSectionGridSub-bKmws {
	grid-template-columns: 50% 49% !important;
}

.ShowFailedPayout-exportText-C67KF {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ShowFailedPayout-exportLinkImg-YJDpn {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ShowFailedPayout-vtrMiddle-jpzI5 {
	vertical-align: middle;
}

.ShowFailedPayout-exportImg-xDiYe {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ShowFailedPayout-profileViewlabel-T8uUj {
	display: inline-block;
	width: 38%
}

.ShowFailedPayout-profileViewMainContent-eZKQm {
	display: inline-block;
	width: 62%;
}

.ShowFailedPayout-profileViewMain-xuMPX {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ShowFailedPayout-profileViewInner-B2M2c {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ShowFailedPayout-profileImageSection-ffz8b {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ShowFailedPayout-lastviewInner-vIHyU {
	padding: 10px;
}

.ShowFailedPayout-whyHostHoriLine-M7HRy {
	margin: 30px 0;
}

.ShowFailedPayout-tableGrid-OGbV1 {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ShowFailedPayout-headingContent-PEXJ9 {
	font-size: 18px;
	font-weight: 500;
}

.ShowFailedPayout-refundTextColor-jIcZ4 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ShowFailedPayout-dividerLine-jGyoT {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ShowFailedPayout-smallContent-Y1A36 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ShowFailedPayout-sideAdminPageWrapper-wOqxo {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ShowFailedPayout-sideAdminPageWrapper-wOqxo {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ShowFailedPayout-exportSection-iTrxO {
		grid-template-columns: 100%;
	}

	.ShowFailedPayout-exportSectionGridSub-bKmws {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ShowFailedPayout-profileViewlabel-T8uUj {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ShowFailedPayout-profileViewMainContent-eZKQm {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ShowFailedPayout-ChangeToUpperCase-D_UcO {
	text-transform: uppercase
}

.ShowFailedPayout-noBorder-Xd0Vx {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ShowFailedPayout-siteAdminHeading-IBhVO {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ShowFailedPayout-siteAdminSubHeading-qgHsp {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ShowFailedPayout-adminFormDivider-iqmXn {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ShowFailedPayout-space1-KseWF {
	margin-bottom: 6px !important;
}

.ShowFailedPayout-space2-4xOcU {
	margin-bottom: 12px !important;
}

.ShowFailedPayout-space3-mxQF6 {
	margin-bottom: 18px !important;
}

.ShowFailedPayout-space4-GV5DB {
	margin-bottom: 24px !important;
}

.ShowFailedPayout-space5-BzFAA {
	margin-bottom: 30px !important;
}

.ShowFailedPayout-space6-EUSTs {
	margin-bottom: 36px !important;
}

.ShowFailedPayout-space7-a33WM {
	margin-bottom: 42px !important;
}

.ShowFailedPayout-spaceTop8-pruiC {
	margin-bottom: 48px !important;
}

.ShowFailedPayout-spaceTop1-ia07f {
	margin-top: 6px !important;
}

.ShowFailedPayout-spaceTop2-ORZ6r {
	margin-top: 12px !important;
}

.ShowFailedPayout-spaceTop3-PjfV4 {
	margin-top: 18px !important;
}

.ShowFailedPayout-spaceTop4-Ve6Zf {
	margin-top: 24px !important;
}

.ShowFailedPayout-spaceTop5-RzL65 {
	margin-top: 30px !important;
}

.ShowFailedPayout-spaceTop6-YUjud {
	margin-top: 36px !important;
}

.ShowFailedPayout-spaceTop7-Fxjtd {
	margin-top: 42px !important;
}

.ShowFailedPayout-spaceTop8-pruiC {
	margin-top: 48px !important;
}

.ShowFailedPayout-noMargin-MtIFx {
	margin: 0px !important;
}

.ShowFailedPayout-padding1-hBFpC {
	padding-bottom: 6px !important;
}

.ShowFailedPayout-padding2-iCHT4 {
	padding-bottom: 12px !important;
}

.ShowFailedPayout-padding3-zJIw8 {
	padding-bottom: 18px !important;
}

.ShowFailedPayout-padding4-bSvSx {
	padding-bottom: 24px !important;
}

.ShowFailedPayout-padding5-dGy4Y {
	padding-bottom: 30px !important;
}

.ShowFailedPayout-padding6-w8pfO {
	padding-bottom: 36px !important;
}

.ShowFailedPayout-padding7-gNrw3 {
	padding-bottom: 42px !important;
}

.ShowFailedPayout-paddingTop1-BHly8 {
	padding-top: 6px !important;
}

.ShowFailedPayout-paddingTop2-pdIyQ {
	padding-top: 12px !important;
}

.ShowFailedPayout-paddingTop3-BwGWR {
	padding-top: 18px !important;
}

.ShowFailedPayout-paddingTop4-JfOGB {
	padding-top: 24px !important;
}

.ShowFailedPayout-paddingTop5-aU0VF {
	padding-top: 30px !important;
}

.ShowFailedPayout-paddingTop6-HvL4b {
	padding-top: 36px !important;
}

.ShowFailedPayout-paddingTop7-ioVjR {
	padding-top: 42px !important;
}

.ShowFailedPayout-noPadding-abCUJ {
	padding: 0px !important;
}

.ShowFailedPayout-textBold-OlVEv {
	font-weight: 500 !important;
}

.ShowFailedPayout-textBolder-oX5Ct {
	font-weight: 700 !important;
}

.ShowFailedPayout-textNormal-eHMwz {
	font-weight: normal !important;
}

.ShowFailedPayout-spaceBottom20-kzepE {
	margin-bottom: 20px;
}

.ShowFailedPayout-spaceBottom10-u7fE1 {
	margin-bottom: 10px;
}

.ShowFailedPayout-marginNone-4DlpP {
	margin: 0;
}

.ShowFailedPayout-spaceBottom15-gV0pt {
	margin-bottom: 15px;
}

.ShowFailedPayout-marginTopNone-jYiOq {
	margin-top: 0;
}

.ShowFailedPayout-spaceTop11-BXGu2 {
	margin-top: 11px;
}

.ShowFailedPayout-spaceTop21-YAxPd {
	margin-top: 21px;
}

.ShowFailedPayout-spaceTop20-hMDdi {
	margin-top: 20px;
}

.ShowFailedPayout-spaceTop10-iZvme {
	margin-top: 10px;
}

/*New Design Text Colors */

.ShowFailedPayout-textDarkBlue-LNOtP {
	color: rgb(20, 39, 94) !important;
}

.ShowFailedPayout-textLightBlue-qEYI3 {
	color: rgb(57, 87, 106) !important;
}

.ShowFailedPayout-textLightSandleGreen-hPTgU {
	color: rgb(76, 86, 41) !important;
}

.ShowFailedPayout-textLightBrown-VN_kE {
	color: rgb(115, 79, 33) !important;
}

.ShowFailedPayout-textMediumMaroon-SD1He {
	color: rgb(87, 37, 51) !important;
}

.ShowFailedPayout-textBrown-PnVgp {
	color: rgb(160, 47, 24) !important;
}

.ShowFailedPayout-textMaroon-SmtVN {
	color: rgb(155, 49, 67) !important;
}

.ShowFailedPayout-textDarkBrown-TtnVa {
	color: rgb(83, 18, 16) !important;
}

.ShowFailedPayout-textMediumBrown-OFhC3 {
	color: rgb(142, 28, 10) !important;
}

.ShowFailedPayout-textSkyBlue-iQJ6E {
	color: rgb(37, 117, 141) !important;
}

.ShowFailedPayout-textGray-TWzda {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ShowFailedPayout-commonHeaderAdmin-JgIjh`,
	"adminLayout": `ShowFailedPayout-adminLayout-Cbt6I`,
	"box": `ShowFailedPayout-box-IKX6n`,
	"exportLink": `ShowFailedPayout-exportLink-xwnSy`,
	"blockCenter": `ShowFailedPayout-blockCenter-nPmNb`,
	"panelHeader": `ShowFailedPayout-panelHeader-kJmgv`,
	"currencyselect": `ShowFailedPayout-currencyselect-mbFOq`,
	"mar0": `ShowFailedPayout-mar0-Ey9FN`,
	"sideAdminPageWrapper": `ShowFailedPayout-sideAdminPageWrapper-wOqxo`,
	"table": `ShowFailedPayout-table-fuz4d`,
	"tableRow": `ShowFailedPayout-tableRow-XfGlr`,
	"tableCell": `ShowFailedPayout-tableCell-dNtMh`,
	"formGroup": `ShowFailedPayout-formGroup-XFHA2`,
	"select": `ShowFailedPayout-select-PKngM`,
	"noMargin": `ShowFailedPayout-noMargin-MtIFx`,
	"labelTextNew": `ShowFailedPayout-labelTextNew-N1yjv`,
	"displayInline": `ShowFailedPayout-displayInline-O3CLu`,
	"btnUPdate": `ShowFailedPayout-btnUPdate-ybKCP`,
	"btnModalDelete": `ShowFailedPayout-btnModalDelete-hROaZ`,
	"radioBtn": `ShowFailedPayout-radioBtn-k2ezm`,
	"backgroundImg": `ShowFailedPayout-backgroundImg-GLfK8`,
	"btnWidth": `ShowFailedPayout-btnWidth-upd2v`,
	"bannerImageBg": `ShowFailedPayout-bannerImageBg-sxKF0`,
	"bannerDelete": `ShowFailedPayout-bannerDelete-GC51s`,
	"modalRoot": `ShowFailedPayout-modalRoot-AmDII`,
	"modalBorderBottom": `ShowFailedPayout-modalBorderBottom-uLvM7`,
	"logInModalBody": `ShowFailedPayout-logInModalBody-YjISC`,
	"exportSection": `ShowFailedPayout-exportSection-iTrxO`,
	"exportSectionGridSub": `ShowFailedPayout-exportSectionGridSub-bKmws`,
	"exportText": `ShowFailedPayout-exportText-C67KF`,
	"exportLinkImg": `ShowFailedPayout-exportLinkImg-YJDpn`,
	"vtrMiddle": `ShowFailedPayout-vtrMiddle-jpzI5`,
	"exportImg": `ShowFailedPayout-exportImg-xDiYe`,
	"profileViewlabel": `ShowFailedPayout-profileViewlabel-T8uUj`,
	"profileViewMainContent": `ShowFailedPayout-profileViewMainContent-eZKQm`,
	"profileViewMain": `ShowFailedPayout-profileViewMain-xuMPX`,
	"profileViewInner": `ShowFailedPayout-profileViewInner-B2M2c`,
	"profileImageSection": `ShowFailedPayout-profileImageSection-ffz8b`,
	"lastviewInner": `ShowFailedPayout-lastviewInner-vIHyU`,
	"whyHostHoriLine": `ShowFailedPayout-whyHostHoriLine-M7HRy`,
	"tableGrid": `ShowFailedPayout-tableGrid-OGbV1`,
	"headingContent": `ShowFailedPayout-headingContent-PEXJ9`,
	"refundTextColor": `ShowFailedPayout-refundTextColor-jIcZ4`,
	"dividerLine": `ShowFailedPayout-dividerLine-jGyoT`,
	"smallContent": `ShowFailedPayout-smallContent-Y1A36`,
	"ChangeToUpperCase": `ShowFailedPayout-ChangeToUpperCase-D_UcO`,
	"noBorder": `ShowFailedPayout-noBorder-Xd0Vx`,
	"siteAdminHeading": `ShowFailedPayout-siteAdminHeading-IBhVO`,
	"siteAdminSubHeading": `ShowFailedPayout-siteAdminSubHeading-qgHsp`,
	"adminFormDivider": `ShowFailedPayout-adminFormDivider-iqmXn`,
	"space1": `ShowFailedPayout-space1-KseWF`,
	"space2": `ShowFailedPayout-space2-4xOcU`,
	"space3": `ShowFailedPayout-space3-mxQF6`,
	"space4": `ShowFailedPayout-space4-GV5DB`,
	"space5": `ShowFailedPayout-space5-BzFAA`,
	"space6": `ShowFailedPayout-space6-EUSTs`,
	"space7": `ShowFailedPayout-space7-a33WM`,
	"spaceTop8": `ShowFailedPayout-spaceTop8-pruiC`,
	"spaceTop1": `ShowFailedPayout-spaceTop1-ia07f`,
	"spaceTop2": `ShowFailedPayout-spaceTop2-ORZ6r`,
	"spaceTop3": `ShowFailedPayout-spaceTop3-PjfV4`,
	"spaceTop4": `ShowFailedPayout-spaceTop4-Ve6Zf`,
	"spaceTop5": `ShowFailedPayout-spaceTop5-RzL65`,
	"spaceTop6": `ShowFailedPayout-spaceTop6-YUjud`,
	"spaceTop7": `ShowFailedPayout-spaceTop7-Fxjtd`,
	"padding1": `ShowFailedPayout-padding1-hBFpC`,
	"padding2": `ShowFailedPayout-padding2-iCHT4`,
	"padding3": `ShowFailedPayout-padding3-zJIw8`,
	"padding4": `ShowFailedPayout-padding4-bSvSx`,
	"padding5": `ShowFailedPayout-padding5-dGy4Y`,
	"padding6": `ShowFailedPayout-padding6-w8pfO`,
	"padding7": `ShowFailedPayout-padding7-gNrw3`,
	"paddingTop1": `ShowFailedPayout-paddingTop1-BHly8`,
	"paddingTop2": `ShowFailedPayout-paddingTop2-pdIyQ`,
	"paddingTop3": `ShowFailedPayout-paddingTop3-BwGWR`,
	"paddingTop4": `ShowFailedPayout-paddingTop4-JfOGB`,
	"paddingTop5": `ShowFailedPayout-paddingTop5-aU0VF`,
	"paddingTop6": `ShowFailedPayout-paddingTop6-HvL4b`,
	"paddingTop7": `ShowFailedPayout-paddingTop7-ioVjR`,
	"noPadding": `ShowFailedPayout-noPadding-abCUJ`,
	"textBold": `ShowFailedPayout-textBold-OlVEv`,
	"textBolder": `ShowFailedPayout-textBolder-oX5Ct`,
	"textNormal": `ShowFailedPayout-textNormal-eHMwz`,
	"spaceBottom20": `ShowFailedPayout-spaceBottom20-kzepE`,
	"spaceBottom10": `ShowFailedPayout-spaceBottom10-u7fE1`,
	"marginNone": `ShowFailedPayout-marginNone-4DlpP`,
	"spaceBottom15": `ShowFailedPayout-spaceBottom15-gV0pt`,
	"marginTopNone": `ShowFailedPayout-marginTopNone-jYiOq`,
	"spaceTop11": `ShowFailedPayout-spaceTop11-BXGu2`,
	"spaceTop21": `ShowFailedPayout-spaceTop21-YAxPd`,
	"spaceTop20": `ShowFailedPayout-spaceTop20-hMDdi`,
	"spaceTop10": `ShowFailedPayout-spaceTop10-iZvme`,
	"textDarkBlue": `ShowFailedPayout-textDarkBlue-LNOtP`,
	"textLightBlue": `ShowFailedPayout-textLightBlue-qEYI3`,
	"textLightSandleGreen": `ShowFailedPayout-textLightSandleGreen-hPTgU`,
	"textLightBrown": `ShowFailedPayout-textLightBrown-VN_kE`,
	"textMediumMaroon": `ShowFailedPayout-textMediumMaroon-SD1He`,
	"textBrown": `ShowFailedPayout-textBrown-PnVgp`,
	"textMaroon": `ShowFailedPayout-textMaroon-SmtVN`,
	"textDarkBrown": `ShowFailedPayout-textDarkBrown-TtnVa`,
	"textMediumBrown": `ShowFailedPayout-textMediumBrown-OFhC3`,
	"textSkyBlue": `ShowFailedPayout-textSkyBlue-iQJ6E`,
	"textGray": `ShowFailedPayout-textGray-TWzda`
};
module.exports = ___CSS_LOADER_EXPORT___;
